<template>
  <div>
    <b-row class="mb-2">
      <b-col cols="8"><b-input type="search" v-model="query.term" placeholder="Suchen..." @keyup="queryKeyUp"></b-input></b-col>
      <b-col cols="2"><b-form-select v-model="query.country" :options="countryOptions" @change="search"></b-form-select></b-col>
      <b-col cols="1"><b-btn variant="primary" @click="search">Suchen</b-btn></b-col>
      <b-col cols="1"><b-btn variant="primary" @click="exportUsers" :disabled="exportDisabled">Exportieren</b-btn></b-col>
    </b-row>

    <b-table id="users_tbl" :fields="table.fields" :items="table.items" responsive>
      <template v-slot:cell(gender)="row">
        {{ row.value ? (row.value == 'male' ? 'Herr' : 'Frau') : '' }}
      </template>

      <template v-slot:cell(name)="row">
        <router-link :to="{name: 'admin.users.details', params: {id: row.item.id}}">
          {{ row.value }}
        </router-link>
      </template>

      <template v-slot:cell(school)="row">
        <router-link :to="{name: 'admin.schools.details', params: {id: row.value.id}}" v-if="row.value">
          {{ row.value.name }}, {{ row.value.city }}  <span v-if="row.value.state">, {{ row.value.state.code }}</span>
        </router-link>
      </template>

      <template v-slot:cell(coordinator)="row">
        {{ row.value ? 'ja' : 'nein'}}
      </template>

      <template v-slot:cell(email)="row">
        {{ row.value }}
      </template>

      <template v-slot:cell(verified)="row">
        <font-awesome-icon icon="check-circle" class="fa-xs text-center" v-if="row.value"></font-awesome-icon>
      </template>
    </b-table>

    <b-row v-if="query.more" class="mb-5">
      <b-col class="text-sm-center"><span @click="exec">mehr</span></b-col>
    </b-row>
  </div>
</template>

<script>
import {getCountries} from '@/lib/locale'

export default {
  name: 'Users',

  data: function () {
    return {
      query: {
        country: null,
        term: '',
        limit: 0,
        offset: 0,
        more: false
      },

      table: {
        items: [],
        fields: [
          {key: 'gender', label: 'Anrede'},
          {key: 'name', label: 'Name'},
          {key: 'school', label: 'Schule'},
          {key: 'country', label: 'Land'},
          {key: 'email', label: 'Email'},
          {key: 'verified', label: ''}
        ]
      }
    }
  },

  mounted: function () {
    if (this.$route.query) {
      if (this.$route.query.q) {
        this.query.term = this.$route.query.q
      }

      if (this.$route.query.country) {
        this.query.country = this.$route.query.country
      }
    }

    this.search()
  },

  computed: {
    exportDisabled: function () {
      return !this.query.country
    },

    countryOptions: function () {
      const options = [{ value: null, text: 'Alle Länder' }]
      const countries = getCountries()

      Object.keys(countries).forEach(code => {
        options.push({value: code, text: countries[code].name})
      })

      return options
    }
  },

  methods: {
    queryKeyUp: function (event) {
      if (event.key === 'Enter') {
        this.search()
      }
    },

    exportUsers: function () {
      this.$eventHub.$emit('download', '/users/export?country=' + this.query.country)
    },

    search: function () {
      this.table.items = []
      this.query.offset = 0
      this.exec()
    },

    exec: function () {
      const config = {params: {}}

      if (this.query.term.trim() !== '') {
        config.params.q = this.query.term.trim()
      }

      if (this.query.country !== null) {
        config.params.country = this.query.country
      }

      if (this.query.limit > 0) {
        config.params.limit = this.query.limit
      }

      if (this.query.offset > 0) {
        config.params.offset = this.query.offset
      }

      if (this.$route.query.q !== config.params.q || this.$route.query.country !== config.params.country) {
        this.$router.replace({name: this.$route.name, query: config.params})
      }

      this.axios.get('/users', config).then(rsp => {
        if (this.query.limit === 0) {
          this.query.limit = rsp.data.limit
        }

        this.query.offset = rsp.data.offset + rsp.data.limit
        this.query.more = rsp.data.more

        rsp.data.users.forEach(row => {
          this.table.items.push({
            id: row.id,
            gender: row.gender,
            name: row.firstname + ' ' + row.lastname,
            firstname: row.firstname,
            lastname: row.lastname,
            email: row.email,
            country: row.country,
            verified: row.emailVerified,
            school: row.school
          })
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/users/Users.vue